import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import Commitment from '@/services/commitments/'
import EvaluationResponse from '@/services/evaluationResponses/'
import EvaluationQuestionSection from '@/services/evaluationQuestionSections/'

import EvaluationAPI from './api'

export default class Evaluation extends Model {
  static api = EvaluationAPI.create(Evaluation)
  static readOnlyFields = [
    'id',
    'organizationName',
    'hasCommitments',
    'isCompleted',
    'isEmpty',
    'sections',
  ]

  constructor({
    id = null,
    name = '',
    questionData = '',
    evaluationData = {},
    application = null,
    evaluator = null,
    hasCommitments = false,
    isCompleted = false,
    isEmpty = false,
    commitments = [],
    responses = [],
    sections = [],
    includeInReport = false,
    createdAt = '',
    evaluationCompleted = false,
    applicationOrder = null,
  } = {}) {
    super()
    Object.assign(this, {
      id,
      name,
      questionData,
      evaluationData,
      application,
      evaluator,
      hasCommitments,
      isCompleted,
      isEmpty,
      commitments,
      responses,
      sections,
      includeInReport,
      createdAt,
      evaluationCompleted,
      applicationOrder
    })
  }

  static create(opts = {}) {
    if (opts.commitments) {
      opts.commitments = opts.commitments.map(Commitment.fromAPI)
    }
    if (opts.responses) {
      opts.responses = opts.responses.map(EvaluationResponse.fromAPI)
    }
    if (opts.sections) {
      opts.sections = opts.sections.map(EvaluationQuestionSection.fromAPI)
    }

    return new Evaluation(opts)
  }

  static fromAPI(json = {}) {
    const camelJson = snakeToCamel(json)
    if (camelJson.commitments) {
      camelJson.commitments = camelJson.commitments.map(Commitment.fromAPI)
    }
    if (camelJson.responses) {
      camelJson.responses = camelJson.responses.map(EvaluationResponse.fromAPI)
    }
    if (camelJson.sections) {
      camelJson.sections = camelJson.sections.map(EvaluationQuestionSection.fromAPI)
    }
    return new Evaluation(camelJson)
  }

  copy() {
    return new Evaluation(this)
  }
}
